export const iconOptions = [
  "dashboard",
  "notifications",
  "smart_toy",
  "analytics",
  "search",
  "account_circle",
  "settings",
  "help",
  "check_circle",
  "info",
  "lock",
  "visibility",
  "email",
  "home",
  "menu",
  "close",
  "add",
  "edit",
  "delete",
  "save",
  "cloud_upload",
  "download",
  "print",
  "visibility_off",
  "warning",
  "error",
  "star",
  "favorite",
  "thumb_up",
  "thumb_down",
  "attach_file",
  "camera_alt",
  "chat",
  "send",
  "calendar_today",
  "event",
  "alarm",
  "access_time",
  "person",
  "people",
  "group",
  "shopping_cart",
  "credit_card",
  "payment",
  "lock_open",
  "security",
  "language",
  "translate",
  "map",
  "location_on",
  "directions",
  "phone",
  "call",
  "sms",
  "share",
  "link",
  "build",
  "code",
  "visibility",
  "bar_chart",
  "pie_chart",
  "timeline",
  "folder",
  "file_copy",
  "description",
  "speed",
  "support",
  "support_agent",
];
